import React from 'react';

function Privacy() {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="updated">Last Updated: November 28, 2025</p>

      <p>
        Little Avalon ("we," "our," or "us") is committed to protecting your privacy. 
        This Privacy Policy explains how we collect, use, disclose, and safeguard your 
        information when you use our mobile application and website (collectively, the "Service").
      </p>

      <h2>Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, delivery address, and payment information when you create an account or place an order.</li>
        <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers, and mobile network information.</li>
        <li><strong>Location Information:</strong> With your consent, we collect precise location data to provide delivery services and show nearby locations.</li>
        <li><strong>Usage Information:</strong> How you interact with our Service, including pages viewed, features used, and order history.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Process and fulfill your orders</li>
        <li>Send order confirmations and delivery updates</li>
        <li>Manage your account and provide customer support</li>
        <li>Process payments securely</li>
        <li>Send promotional offers and rewards notifications (with your consent)</li>
        <li>Improve our Service and develop new features</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>Information Sharing</h2>
      <p>We may share your information with:</p>
      <ul>
        <li><strong>Delivery Partners:</strong> Third-party delivery services (such as DoorDash) to fulfill delivery orders. They receive only the information necessary to complete the delivery.</li>
        <li><strong>Payment Processors:</strong> Square and other payment providers to process transactions securely.</li>
        <li><strong>Service Providers:</strong> Third parties that help us operate our Service, such as cloud hosting and analytics providers.</li>
        <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety.</li>
      </ul>

      <h2>Data Security</h2>
      <p>
        We implement appropriate technical and organizational security measures to protect 
        your personal information. Payment information is processed through PCI-compliant 
        payment processors and is never stored on our servers.
      </p>

      <h2>Your Choices</h2>
      <p>You have the following rights regarding your information:</p>
      <ul>
        <li><strong>Account Information:</strong> You can update your account information at any time through the app.</li>
        <li><strong>Location Services:</strong> You can enable or disable location services through your device settings.</li>
        <li><strong>Push Notifications:</strong> You can manage notification preferences in the app settings.</li>
        <li><strong>Marketing Communications:</strong> You can opt out of promotional emails by clicking "unsubscribe" or adjusting your preferences.</li>
        <li><strong>Account Deletion:</strong> You can request deletion of your account by contacting us.</li>
      </ul>

      <h2>Children's Privacy</h2>
      <p>
        Our Service is not intended for children under 13 years of age. We do not knowingly 
        collect personal information from children under 13. If you believe we have collected 
        information from a child under 13, please contact us immediately.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        Our Service may contain links to third-party websites or services. We are not 
        responsible for the privacy practices of these third parties. We encourage you 
        to review their privacy policies.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any 
        changes by posting the new Privacy Policy on this page and updating the "Last Updated" 
        date. Your continued use of the Service after changes constitutes acceptance of the 
        updated policy.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy or our privacy practices, please contact us at:
      </p>
      <p>
        <strong>Little Avalon</strong><br />
        9410 W Sahara Ave Ste 130<br />
        Las Vegas, NV 89117<br />
        Phone: (702) 462-9252<br />
        Email: privacy@littleavalon.com
      </p>
    </div>
  );
}

export default Privacy;
